import { render, staticRenderFns } from "./banka.vue?vue&type=template&id=7d2c51a4&"
import script from "./banka.vue?vue&type=script&lang=js&"
export * from "./banka.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports